import React from 'react';
import { Col, Layout, message, Row, Select ,Icon} from 'antd';
import moment from "moment";
import MiCompAPI from "../../util/api";
import ReportTableWrapper from "../elements/ReportTableWrapper";
import ExportJsonExcel from 'js-export-excel';
const { Content } = Layout;
const { Option } = Select;
class ClientSummary extends React.Component {
    columns = [{
        title: 'Plan Id',
        dataIndex: 'client_plan_Id',
        sorter: (a, b) => a.client_plan_Id.localeCompare(b.client_plan_Id),
        sortDirections: ["descend", "ascend"]
    }, {
        title: 'Plan Name',
        dataIndex: 'plan_Name',
        sorter: (a, b) => a.plan_Name.localeCompare(b.plan_Name),
        sortDirections: ["descend", "ascend"]
    },
    {
        title: 'Start Date',
        dataIndex: 'start_date',
        render: (text, record) => record["start_date"] !== null && record["start_date"] !== "" ? moment(record["start_date"]).format("MM/DD/YYYY") : "none",
        sorter: (a, b) => new Date(a.start_date) - new Date(b.start_date),
        sortDirections: ["descend", "ascend"]
    }, {
        title: 'End Date',
        dataIndex: 'end_date',
        render: (text, record) => record["end_date"] !== null && record["end_date"] !== "" ? moment(record["end_date"]).format("MM/DD/YYYY") : "none",
        sorter: (a, b) => new Date(a.end_date) - new Date(b.end_date),
        sortDirections: ["descend", "ascend"]
    },  {
        title: 'LOA',
        dataIndex: 'loB_Name',
        sorter: (a, b) => a.loB_Name.localeCompare(b.loB_Name),
        sortDirections: ["descend", "ascend"]
    }, {
        title: 'Unit Of Measure',
        dataIndex: 'uom_name',
        sorter: (a, b) => a.uom_name.localeCompare(b.uom_name),
        sortDirections: ["descend", "ascend"]
    }, ];
    constructor(props) {
        super(props);
        this.state = {
            carriers: null,
            client_plan_summary: [],
            isLoading: false,
            int_client: null
        }
        this.tableButtons = [{
            buttonType: "primary",
            content: "Export Excel",
            clickHandler: () => {
                this.downloadExcel();
            }
        }];
        this.api = new MiCompAPI(this.props.userPermandMasters);
    }
    downloadExcel = () => {
        const data = this.state.client_plan_summary.client_Summary ? this.state.client_plan_summary.client_Summary : '';//tabular data
        var option = {};
        let dataTable = [];
        if (data) {
            for (let i in data) {
                if (data) {
                    let obj = {
                        'Plan Id': data[i].client_plan_Id,
                        'Plan Name': data[i].plan_Name,
                        'Start Date': data[i].start_date ? moment(data[i].start_date).format("MM/DD/YYYY") : null,
                        'End Date': data[i].end_date ? moment(data[i].end_date).format("MM/DD/YYYY") : null,
                        'LOA': data[i].loB_Name,
                        'Unit Of Measure': data[i].uom_name,
                    }
                    dataTable.push(obj);
                }
            }
        }
        option.fileName = 'ClientSummary'
        option.datas = [
            {
                sheetData: dataTable,
                sheetName: 'sheet',
                sheetFilter: ['Plan Id', 'Plan Name',  'Start Date', 'End Date',  'LOA', 'Unit Of Measure'],
                sheetHeader: ['Plan Id', 'Plan Name',  'Start Date', 'End Date',  'LOA', 'Unit Of Measure'],
            }
        ];
        if(dataTable.length>0){
            var toExcel = new ExportJsonExcel(option);
            toExcel.saveExcel();
        }
    }
    componentDidMount = () => {
        this.getClientMasters();
    }
    onChange = (e) => {
        this.GetClientSummary(e);
    }
    GetClientSummary(client_id) {
        this.setState({
            isLoading: true
        })
        this.api.invoke(
            "GetClientSummary/" + client_id,
            "get",
            (data, success) => {
                if (success) {
                    if (data.statusCode === 200) {
                        setTimeout(() => {
                            this.setState({
                                isLoading: false,
                                client_plan_summary: data.data
                            })
                        }, 100);
                    } else {
                        message.destroy();
                        message.error(data.statusMessage, 3);
                    }
                }
            });
    }
    getClientMasters() {
        this.api.invoke(
            "GetMasters",
            "post",
            (data, success) => {
                if (success) {
                    setTimeout(() => {
                        if(data.carriers[0])
                        this.GetClientSummary(data.carriers[0]?data.carriers[0].id:null);
                    }, 100);
                    this.setState({
                        int_client: data.carriers[0]?data.carriers[0].id:null,
                        carriers: data.carriers
                    });
                }
            },
            ["CARRIER"]
        );
    }
    render() {
        var { client_Address } = this.state.client_plan_summary;
        return (
            <Content>
                <div className="mi_main_div">
                    <Row style={{ padding: '20px', background: 'white' }}>
                        <Col span={24}>
                            <p className="mi_table_title" style={{ textAlign: 'center', marginBottom: '40px' }}>Carrier Summary Report</p>
                        </Col>
                        <Col span={24} style={{ marginBottom: '40px' }}>
                            <Row span={24}>
                                {this.state.int_client ?
                                    <Col span={12} >
                                        <h3><b>Carrier : </b></h3>
                                        <Select suffixIcon={<Icon style={{transform:'rotate(90deg)'}} type="double-right" />} style={{ width: '300px' }} className="mi_input_profile"
                                            onChange={this.onChange.bind(this)}
                                            placeholder="Please Select Carrier *"
                                            showSearch={true}
                                            optionFilterProp="children"
                                            filterOption={(input, option) =>
                                                option.props.children
                                                    .toLowerCase()
                                                    .indexOf(input.toLowerCase()) >= 0
                                            }
                                            defaultValue={this.state.int_client?this.state.int_client:undefined}
                                        >
                                            {this.state.carriers ? this.state.carriers.map((tag) => (
                                                <Option value={tag.id} key={tag.id}>
                                                    {tag.name.split(' ')
                                                        .map(w => w[0].toUpperCase() + w.substr(1).toLowerCase())
                                                        .join(' ')}
                                                </Option>
                                            )) : ''}
                                        </Select>
                                    </Col>
                                    : <Col span={12} ></Col>}
                                <Col span={12} >
                                    <Row style={{ width: '300px', float: 'right' }}>
                                        <Col span={24}><h4><b>Contact Name :</b> {client_Address ? client_Address.client_contact_name.split(' ')
                                            .map(w => w[0].toUpperCase() + w.substr(1).toLowerCase())
                                            .join(' ') : ''}</h4></Col>
                                        <Col span={24}><h4><b>Address :</b> {client_Address ? client_Address.client_name + ", " + client_Address.client_address_1+(client_Address.client_address_2?', '+client_Address.client_address_2:"") + ', ' + client_Address.city + ', ' + client_Address.stateName.split(' ')
                                            .map(w => w[0].toUpperCase() + w.substr(1).toLowerCase())
                                            .join(' ') + ', ' + client_Address.zip : ''}</h4></Col>
                                        <Col span={24}><h4><b>Phone Number :</b> {client_Address ? (client_Address.client_phone.length === 10 ? <a href={"tel:+" + client_Address.client_phone}>{"(" + client_Address.client_phone.substring(0, 3) + ") " + client_Address.client_phone.substring(3, 6) + "-" + client_Address.client_phone.substring(6)}</a> : "Invalid US Number") : ''}</h4></Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Col>
                        <Col span={24}>
                            <ReportTableWrapper rowKey="tier_profile_name" columns={this.columns} data={this.state.client_plan_summary ? this.state.client_plan_summary.client_Summary : null} loading={this.state.isLoading} buttons={this.tableButtons} search={true} />
                        </Col>
                    </Row>
                </div>
            </Content>
        );
    }
}
export default ClientSummary;